import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Transparent "window" between panels — the showreel shows through while a
// giant outlined headline drifts past at parallax speed.
export const ParallaxDivider = ({ text, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(scrollYProgress, [0, 1], ["4%", "-14%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.35, 0.65, 1], [0.2, 1, 1, 0.2]);

  return (
    <section
      ref={ref}
      className="relative h-[34vh] sm:h-[44vh] flex items-center overflow-hidden"
      data-testid={testId}
      aria-hidden="true"
    >
      <motion.h2
        style={{ x, opacity }}
        className="outline-text font-display uppercase whitespace-nowrap leading-none text-[17vw] sm:text-[11vw] select-none transform-gpu will-change-transform"
      >
        {text} — {text} — {text}
      </motion.h2>
    </section>
  );
};
